
export const act_LoadSection = (payload) => ({ type:'LOAD_SECTION', payload })

